module.exports = __webpack_public_path__ + "img/mech-air-props.a7ffe993.jpg";